import { Avatar, Text } from '@percent/lemonade'
import { createShortLink } from '@poweredbypercent/utility-core'
import styled from 'styled-components'
import { OrganisationHeaderWithImageProps } from './organisation-header-with-image.types'
import { OrganisationNameAndFlag } from './components/organisation-name-and-flag/organisation-name-and-flag'

const StyledCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 20px;

  > *:last-child {
    flex: none;
  }
`

const StyledCardContentLinks = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;

    p:nth-of-type(1) {
      margin-top: 4px;
    }
  }

  p:nth-child(n + 2):last-child {
    display: inline-flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 600px) {
      align-items: flex-start;
    }

    &::before {
      content: '';
      display: inline-block;
      width: 1px;
      height: 25px;
      margin: 0 8px;
      background: #e1e2e3;

      @media (max-width: 600px) {
        display: none;
      }
    }
  }
`

const StyledLink = styled.a`
  ${({ theme }) =>
    `color:  ${theme.colors.primary};
    font-weight: 400;
  `}
`

const StyledOrganisationHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`

export const OrganisationHeaderWithImage = ({
  registryId,
  iconUrl,
  title,
  countryCode,
  website,
  badge,
  badgeTooltip,
}: OrganisationHeaderWithImageProps) => {
  return (
    <StyledCardHeader>
      <StyledOrganisationHeader>
        <OrganisationNameAndFlag name={title} countryCode={countryCode} />
        <StyledCardContentLinks>
          {website ? (
            <StyledLink
              href={website}
              target="_blank"
              rel="noopener noreferrer"
            >
              {createShortLink(website)}
            </StyledLink>
          ) : null}
          {registryId && (
            <Text as="p" size="small">
              {registryId}
            </Text>
          )}
        </StyledCardContentLinks>
      </StyledOrganisationHeader>
      {iconUrl ? (
        <Avatar
          image={iconUrl}
          alt={title || ''}
          size="large"
          shape="oval"
          border
          badge={badge || undefined}
          badgeTooltip={badgeTooltip || undefined}
        />
      ) : null}
    </StyledCardHeader>
  )
}
